// App.js

import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ConfigProvider, theme, Layout } from "antd";

import ProtectedRoute from "./ProtectedRoute";
import NavigationBar from "./NavigationBar";
import PageReport from "./PageReport";
import LoginPage from "./loginPage";
import StudyList from "./StudyList";
import ConfirmUserPage from "./confirmUserPage";
import HomePage from "./homePage";
import A2zEditor from "./A2zEditor";
import "./App.css";

const { Header, Content, Footer } = Layout;


const App: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        algorithm: [theme.darkAlgorithm],
      }}
    >
      <BrowserRouter>
        <Layout className="layout" style={{ minHeight: '100vh' }}>
          <Header>
            <NavigationBar />
          </Header>
          <Content style={{ padding: '20px 50px' }}> {/* Added padding */}
            <Routes>
              <Route path="/" element={<Navigate replace to="/home" />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/confirm" element={<ConfirmUserPage />} />
              <Route path="/editor/:mrn" element={<A2zEditor/>} />
              <Route
                path="/home"
                element={
                  <ProtectedRoute>
                    <HomePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/studylist"
                element={
                  <ProtectedRoute>
                    <StudyList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reports/:mrn"
                element={
                  <ProtectedRoute>
                    <PageReport />
                  </ProtectedRoute>
                }
              />
               <Route
                path="/editor/:mrn"
                element={
                  <ProtectedRoute>
                    <A2zEditor />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Content>
          <Footer style={{ textAlign: 'center' }}>
            ©{new Date().getFullYear()} Created by a2z Radiology AI
          </Footer>
        </Layout>
      </BrowserRouter>
    </ConfigProvider>
  );
};

export default App;
